var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 19.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9c9c9c;\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #9c9c9c;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.48,
    y1: 19.04,
    x2: 22.68,
    y2: 19.04
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.63,11.62L14.8.55c.1-.08.24-.07.32.03l5.92,7.04c.08.1.07.24-.03.32l-13.16,11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.66,11.67l-1.15,6.59c-.07.39.25.77.65.77h6.58c.25,0,.37-.29.2-.48l-5.87-6.98c-.13-.16-.38-.1-.42.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: ".87 15.5 4.16 19.41 .35 19.08 .87 15.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.26049485d5077d9cdd1a576b809c15ec.svg";
export { ForwardRef as ReactComponent };